<template>
  <div>
    <div style="margin-bottom: 50px;" v-for="(slide,index) in slides" :key="index">
      <SlideForm
        :slide="slide"
        :slideIndex="index"
      ></SlideForm>
      <p><a @click="deleteSlide(index)">Удалить слайд</a></p>
    </div>
    <p><a @click="addSlide" class="button2">Добавить слайд</a></p>
  </div>
</template>

<script>
import SlideForm from "@/components/HomeSlider/SlideForm";

export default {
  name: "SliderPage",
  components: {
    SlideForm
  },
  data() {
    return {
      id: 0,
      slides: [],
      competitions: []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      const self = this;
      window.$.ajax({
        dataType: "json",
        type : 'get',
        contentType: "application/ld+json;",
        url: "/api/page_metas?meta_key=main_slider",
        success: function(data) {
          self.id = data[0].id;
          self.slides = data[0].jsonValue;
        },
        error: function(data) {
          console.log(data);
        }
      });

      window.$.ajax({
        dataType: "json",
        type : 'get',
        contentType: "application/ld+json;",
        url: "/api/competitions",
        success: function(data) {
          self.competitions = data;
        },
        error: function(data) {
          console.log(data);
        }
      });
    },
    deleteSlide(index) {
      this.slides = this.slides.filter(function(el, inner_index) {return inner_index !== index;});
      this.saveData();
    },
    saveData() {
      const self = this;
      window.$.ajax({
        dataType: "json",
        type : 'patch',
        contentType: "application/merge-patch+json;",
        data: JSON.stringify({
          jsonValue: this.slides
        }),
        url: '/api/page_metas/'+ this.id,
        success: function(data) {
          console.log(data);
          self.getData();
        },
        error: function(data) {
          console.log(data);
        }
      });
    },
    addSlide() {
      this.slides.push({
        text1: "",
        text2: "",
        link: "",
        image: ""
      })
    }
  }
}
</script>

<style scoped>

</style>